import { PackageStatuses } from '../types/packager-types';

// Mirror the API's packager/lifecycles.py sets. A package that has ever delivered
// (transmitted_at set) is neither edited nor re-rendered, whatever its status:
// it is recreated with create-from-package. The API refuses either with a 409.
const ENTRY_EDITABLE_STATUSES = new Set<PackageStatuses>([
  PackageStatuses.CREATED,
  PackageStatuses.PROCESSING_SUCCESSFUL,
  PackageStatuses.VERIFIED,
  PackageStatuses.DRAFT,
]);

const RERENDERABLE_STATUSES = new Set<PackageStatuses>([
  PackageStatuses.CREATED,
  PackageStatuses.PROCESSING_SUCCESSFUL,
  PackageStatuses.PROCESSING_FAILED,
  PackageStatuses.VERIFIED,
  PackageStatuses.DRAFT,
  PackageStatuses.TRANSMISSION_FAILED,
]);

export const isEntryEditable = (
  status?: PackageStatuses | null,
  transmittedAt?: string | null
): boolean => !!status && ENTRY_EDITABLE_STATUSES.has(status) && !transmittedAt;

export const isReRenderable = (
  status?: PackageStatuses | null,
  transmittedAt?: string | null
): boolean => !!status && RERENDERABLE_STATUSES.has(status) && !transmittedAt;
